import { createFileRoute, Outlet } from "@tanstack/react-router";

const PromisLayout = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_private/promis")({
  component: PromisLayout,
});
